<template>
  <div class="good-attr">
    <Row>
        <Col :xs="24" :sm="24">
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <FormItem>
                   <Button @click="showModel()" type="success" class="f-r">添加属性</Button>
                </FormItem> 
            </Form>
        </Col>
    </Row>
    <Table border :columns="columns1" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page ref="listPage" :total="pages.total" :current="pages.current" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
            </div>
        </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus" title="添加属性" @on-ok="createAttr('attrValidate')" :loading="loading">
        <Form :model="attr" ref="attrValidate" :rules="attrValidate" action="javascript:void(0)">
            <FormItem label="商品分类" prop="cate">
                <Cascader :data="cateList" v-model="selectCate" @on-change="cateSelect"></Cascader>
            </FormItem>
            <FormItem label="属性名称" prop="name">
                <Input v-model="attr.name" placeholder="输入属性名称..."></Input>
            </FormItem>
            <FormItem label="排序" prop="sort">
                <Input v-model="attr.sort" placeholder="输入排序..."></Input>
            </FormItem>
        </Form>
    </Modal>
     <!-- 修改的弹出 -->
    <Modal v-model="showEditInfoStatus" title="修改属性" @on-ok="updateAttr('attrValidate')" :loading="loading">
        <Form :model="attr" ref="attrValidate" :rules="attrValidate" action="javascript:void(0)">
            <FormItem label="商品分类" prop="cate">
                <Cascader :data="cateList" v-model="selectCate" @on-change="cateSelect"></Cascader>
            </FormItem>
            <FormItem label="属性名称" prop="name">
                <Input v-model="attr.name" placeholder="输入属性名称..."></Input>
            </FormItem>
            <FormItem label="排序" prop="sort">
                <Input v-model="attr.sort" placeholder="输入排序..."></Input>
            </FormItem>
        </Form>
    </Modal>
  </div>
</template>

<script>
export default {
    name: 'good-attr',
    data () {
        return {
            loading: true,
            dataloading: true,
            cateList: [], // 请求分类
            selectCate: [],
            selectCateId: '',
            formItem:[],
            pages:{
                current:1,
                size:10
            },
            columns1: [
              {
                  title: '排序',
                  key: 'sort',
                  width:100,
                  fixed: 'left'
              },
              {
                  title: 'Id',
                  key: 'id',
                  minWidth:100,
                  fixed: 'left'
              },
              {
                title: '标题',
                key: 'name',
                minWidth:100,
                fixed: 'left'
              },
              {
                title: '分类名称',
                key: 'good_cate_name',
                minWidth:100,
                fixed: 'left'
              },
              {
                title: '操作',
                key: 'action',
                width:200,
                align: 'left',
                render: (h, params) => {
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'info',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.showEditInfo(params.row.id)
                                }
                            }
                        }, '修改'),
                        h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    this.remove(params.row.id)
                                }
                            }
                        }, '删除')
                    ]);
                }
              }
            ],
            tablelist: [],
            attr:{
                name:'',
                cates:[],
                sort:0,
            },
            showModalStatus:false,
            showEditInfoStatus:false,
            attrValidate: {
                name: [
                    { required: true, message: '属性名称必须填写', trigger: 'blur' }
                ]
            },
        }
    },
    // 计算
    computed: {
    },
    // 监听
    watch:{
    },
    created: function () {
        // 取数据
        this.getTableList();
        this.getCateData();
    },
    methods:{
        getTableList:function(){
            var params = {page:this.pages.current,size:this.pages.size};
            this.$api.goodattr.list(params).then(res=>{
                this.dataloading = false;
                if(res.code == 200)
                {
                    this.tablelist = res.result.list;
                    this.pages.total = res.result.total;
                    this.$Message.success(res.msg);
                }
            });
            return;
        },
        changePage(){
            this.pages.current = this.$refs['listPage'].currentPage;
            this.getTableList();
        },
        // 获取分类
        getCateData: function() {
            this.$api.goodcate.list().then(res => {
                if (res.code == 200) {
                    var total = res.result;
                    var arr = new Array();
                    for (var i in total) {
                        var di = {
                            value: total[i].f_id,
                            label: total[i].f_name,
                            children: []
                        }
                        for (var j in total[i].childs) {
                            di.children.push({
                                value: total[i].childs[j].s_id,
                                label: total[i].childs[j].s_name,
                            })
                        }
                        arr.push(di)
                    }
                    this.cateList = arr;
                }
            });
            return;
        },
        //选择分类
        cateSelect(value, selectedData) {
            var end = selectedData[selectedData.length-1]
            console.log(end)
            this.selectCateId = end.value
        },
        // 展开添加
        showModel(){
            this.attr = {}
            this.selectCate = []
            this.$refs['attrValidate'].resetFields();
            this.showModalStatus = !this.showModalStatus;
        },
        // 添加
        createAttr(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$api.goodattr.create({name:this.attr.name,cate_id:this.selectCateId,sort:this.attr.sort}).then(res=>{
                        if(res.code == 200)
                        {
                            this.showModalStatus = !this.showModalStatus;
                            this.attr.name = '';
                            this.getTableList();
                        }
                    });
                    this.loading = false
                    this.$nextTick(() => {this.loading = true;});
                } else {
                    this.$Message.error('请检查输入的信息是否正确！');
                    this.loading = false
                    this.$nextTick(() => {this.loading = true;});
                }
            })
        },
        //展开修改
        showEditInfo:function(index){
            this.attr = {}
            this.selectCate = []
            this.attrid = index;
            this.$refs['attrValidate'].resetFields();
            this.showEditInfoStatus = !this.showEditInfoStatus;
            // 取信息
            this.$api.goodattr.detail({attrid:index}).then(res=>{
                if(res.code == 200) {
                    this.attr = res.result;
                    var selectCate = []
                    console.log(this.cateList)
                    for (let i = 0; i < this.cateList.length; i++) {
                        const cate = this.cateList[i];
                        
                        if (cate.value == this.attr.cate_id) {
                            selectCate.push(cate.value)
                            this.selectCateId = cate.value
                            break
                        } else {
                            var success = false
                            for (let j = 0; j < cate.children.length; j++) {
                                const subCate = cate.children[j];
                                console.log(subCate.value)
                                if (subCate.value == this.attr.cate_id) {
                                    selectCate.push(cate.value)
                                    selectCate.push(subCate.value)
                                    this.selectCateId = subCate.value
                                    success = true
                                    break
                                }
                            }
                            if (success) {
                                break
                            }
                        }
                    }
                    console.log(selectCate)
                    this.selectCate = selectCate
                    this.$Message.success(res.msg);
                }
                this.loading = false;
                this.$nextTick(() => {this.loading = true;});
            });
        },
        // 修改名称
        updateAttr:function(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$api.goodattr.edit({attrid:this.attrid,name:this.attr.name,sort:this.attr.sort,cate_id:this.selectCateId}).then(res=>{
                        if(res.code == 200)
                        {
                            this.$Message.success(res.msg);
                            this.showEditInfoStatus = !this.showEditInfoStatus;
                            this.getTableList();
                        }
                        this.loading = false;
                        this.$nextTick(() => {this.loading = true;});
                        this.showCreateStatus = !this.showCreateStatus;
                    });
                } else {
                    this.$Message.error('请检查输入的信息是否正确！');
                    this.loading = false
                    this.$nextTick(() => {this.loading = true;});
                }
            })
        },
        remove:function(index){
            // 弹出确认框
            this.$Modal.confirm({
                title: '警告',
                content: '<p>此操作不可恢复，三思而后行...</p>',
                onOk: () => {
                    this.$api.goodattr.remove({attrid:index}).then(res=>{
                        if(res.code == 200)
                        {
                            this.$Message.success(res.msg);
                            // this.tablelist.splice(index, 1);
                            this.getTableList();
                        }
                    });
                }
            });
        },
    },
}
</script>
